import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../tailwind.config";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default ({ _ }, inject) => {
  const fullConfig = resolveConfig(tailwindConfig);
  inject("tailwind", fullConfig);
};
